import React from 'react';
import { useTranslation } from 'react-i18next';

import booksLibrayImg from '../../assets/img/books.png';
import examsLibrayImg from '../../assets/img/exams.png';
import decorIconSubject from '../../assets/img/icon_big.png';
import notebookLibrayImg from '../../assets/img/notebooks.png';
import SubjectItem from '../../Components/SubjectItem';

import './style.scss';

const Library = ({ mail }) => {
  const { t } = useTranslation();

  const nameSubjects1 = [
    // {
    //   name: 'homeworks',
    //   img: examsLibrayImg,
    // },
    {
      name: 'exams',
      img: examsLibrayImg,
    },
    {
      name: 'exams-tab',
      img: examsLibrayImg,
    },
  ];
  const nameSubjects2 = [
    {
      name: 'books',
      img: booksLibrayImg,
    },
    // {
    //   name: 'notebooks',
    //   img: notebookLibrayImg,
    // },
  ];

  return (
    <div className="library-page container">
      <div className="decor-item-img">
        <img src={decorIconSubject} alt="decor-icon" />
      </div>

      <div className="title-wrap">
        <h1>{t('library')}</h1>
      </div>

      <div className="row-subjects mb-4">
        {nameSubjects1.map(({ name, img }) => (
          <SubjectItem key={name} nameItem={name} img={img} mail={mail} />
        ))}
      </div>
      <div className="row-subjects">
        {nameSubjects2.map(({ name, img }) => (
          <SubjectItem key={name} nameItem={name} img={img} mail={mail} />
        ))}
      </div>
    </div>
  );
};

export default Library;
